import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../components/Header'
import Footer from '../../components/Footer'

export default () => {
  return (
    <>
      <Header />
      <div className={'container'}>
        <h2>Панель администрирования</h2>
        <nav>
          <Link to={'/admin/courses'}>Курсы</Link> |{' '}
          <Link to={'/admin/achievements'}>Достижения</Link> |{' '}
          <Link to={'/admin/users'}>Пользователи</Link>
        </nav>
      </div>
      <Footer />
    </>
  )
}
